/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/component/BasicBarChart/BasicBarChart.tsx
*/

import React, { useState, useEffect, RefObject } from "react";
//import "./BasicBarChart.scss";
import * as d3 from "d3"; // yarn add d3 @types/d3
import { Types } from "./types";
import { Console } from "console";

const BasicBarChartObsModelo = (props: IBasicBarChartProps) => {
  const [myState, setMyState] = useState<Boolean>(true);
  const ref: RefObject<HTMLDivElement> = React.createRef();

  useEffect(() => {
    console.log(props.data);
    draw();
  });

  const draw = () => {
    const width = props.width - props.left - props.right;
    const height = props.height - props.top - props.bottom;

    const x = d3.scaleBand().range([0, width]).padding(0.1);
    const y = d3.scaleLinear().range([height, 0]);

    d3.select(".basicBarChartObsModelo").html("");

    const svg = d3
      .select(".basicBarChartObsModelo")
      .append("svg")
      .attr("width", width + props.left + props.right)
      .attr("height", height + props.top + props.bottom)
      .append("g")
      .attr("transform", `translate(${props.left},${props.top})`)
      .attr("style", "max-width: 100%; height: auto; height: intrinsic;");

      x.domain(
        props.data.map((d) => {
          return d.framework;
        })
      );

      y.domain([
        0,
        d3.max(props.data, (d) => {
          return Math.max(...props.data.map((dt) => (dt as Types.Data).value), 0);
        }),
      ] as number[]);

      svg
        .selectAll(".bar")
        .data(props.data)
        .enter()
        .append("rect")
        .attr("fill", props.fill)
        .attr("class", "bar")
        .attr("x", (d) => {
          return x(d.framework) || 0;
        })
        .attr("width", x.bandwidth())
        .attr("y", (d) => {
          return y(d.value);
        })     
        .attr("height", (d) => {
          return height - y(d.value);
        });

      // add the x Axis
      svg
        .append("g")
        .attr("transform", `translate(0,${height})`)
        .attr("class", "ms-fontWeight-semibold")
        /* .style('color', '#FFFFFF') */
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("transform", "rotate(270)")
        .attr("x", "10")
        .attr("y", "-3")
        .style("text-anchor", "start");

      // add the y Axis
      svg
        .append("g")
        .attr("class", "ms-fontWeight-semibold")
        .call(d3.axisLeft(y));

    /* d3.dsv(",", `${process.env.PUBLIC_URL}/data/dataCruzada.csv`, (d) => {
      return d as unknown as Types.Data;
    }).then((data) => {
      // Scale the range of the Data in the domains

      x.domain(
        data.map((d) => {
          return d.framework;
        })
      );
      y.domain([
        0,
        d3.max(data, (d) => {
          return Math.max(...data.map((dt) => (dt as Types.Data).value), 0);
        }),
      ] as number[]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", props.fill)
        .attr("class", "bar")
        .attr("x", (d) => {
          return x(d.framework) || 0;
        })
        .attr("width", x.bandwidth())
        .attr("y", (d) => {
          return y(d.value);
        })
        .attr("height", (d) => {
          return height - y(d.value);
        });

      // add the x Axis
      svg
        .append("g")
        .attr("transform", `translate(0,${height})`)
        .attr("class", "ms-fontWeight-semibold")
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("transform", "rotate(270)")
        .attr("x", "10")
        .attr("y", "-3")
        .style("text-anchor", "start");

      // add the y Axis
      svg
        .append("g")
        .attr("class", "ms-fontWeight-semibold")
        .call(d3.axisLeft(y));
    }); */
  };

  return <div className="basicBarChartObsModelo" />;
};

interface IBasicBarChartProps {
  // TODO
  width: number;
  height: number;
  top: number;
  right: number;
  bottom: number;
  left: number;
  fill: string;
  data: Types.Data[],
}

export default BasicBarChartObsModelo;
